// removed by extract-text-webpack-plugin
module.exports = {"icon":"_2NoYADQT8GKYPVR6yLrYOE","text":"_1w6FnJXCaxU-2_QNY9Qowz","menuItem":"lCKSMvQdQ1FB95d0tfeeR","button":"_3NyFMyaXtOaU45KQS4QQ5-"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/PopoverMenuItem/PopoverMenuItem.scss
// module id = ./node_modules/wix-style-react/dist/es/src/PopoverMenuItem/PopoverMenuItem.scss
// module chunks = 0